import React from 'react'

interface ByGemioProps {
    loading?: boolean;
}

const recommendations = [
    { title: 'Best Rated', image: 'https://picsum.photos/seed/bestrated/400/400' },
    { title: 'Most Relevant', image: 'https://picsum.photos/seed/relevant/400/400' },
    { title: 'On the Rise', image: 'https://picsum.photos/seed/rise/400/400' }
  ];

const ByGemio = ({ loading }: ByGemioProps) => {
  return (
      <div className="mb-2">
        <h2 className="text-lg ml-2 pb-2 font-bold poppins-semibold text-[#bf491e]">Gemio recommends</h2>
        <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide">
          {recommendations.map((rec, idx) => (
            <div key={idx} className="flex-shrink-0 w-30">
              <div className="relative rounded-xl overflow-hidden shadow-md mb-2 h-30">
                <img 
                  src={rec.image} 
                  alt={rec.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <h3 className="font-semibold text-gray-900 text-center hover:text-[var(--title-primary)]">{rec.title}</h3>
            </div>
          ))}
        </div>
      </div>
  )
}

export default ByGemio